module.exports = __webpack_public_path__ + "static/media/oberflex-noyerameriquet160-2560x1440.c6d094df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyerameriquet160-2560x1440.jpg
// module id = 1039
// module chunks = 37